 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_SERIES_EDITOR from '@/components/xhtml/01_Series_Editor'
 import XHTML02_TITLE_PAGE from '@/components/xhtml/02_Title_Page'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML04_DEDICATION from '@/components/xhtml/04_Dedication'
 import XHTML05_CONTENTS from '@/components/xhtml/05_Contents'
 import XHTML06_A_NOTE_ON_THE_TITLE from '@/components/xhtml/06_A_Note_on_the_Title'
 import XHTML07_ACKNOWLEDGMENTS from '@/components/xhtml/07_Acknowledgments'
 import XHTML08_A_NOVELIST_READS_THE_TALMUD__AN from '@/components/xhtml/08_A_Novelist_Reads_the_Talmud__An'
 import XHTML09_TIMELINE_OF_RELEVANT_EVENTS__ACC from '@/components/xhtml/09_Timeline_of_Relevant_Events__Acc'
 import XHTML10_MEMO_ONE__RABBI_YOHANAN_AND_RABB from '@/components/xhtml/10_MEMO_ONE__Rabbi_Yohanan_and_Rabb'
 import XHTML11_CHAPTER_1__EROS_AND_ALCHEMY_IN_T from '@/components/xhtml/11_CHAPTER_1__Eros_and_Alchemy_in_t'
 import XHTML12_MEMO_TWO__RABBI_SHIMON_BAR_YOHAI from '@/components/xhtml/12_MEMO_TWO__Rabbi_Shimon_bar_Yohai'
 import XHTML13_CHAPTER_2__TURNING_THE_HEARTS_OF from '@/components/xhtml/13_CHAPTER_2__Turning_the_Hearts_of'
 import XHTML14_MEMO_THREE_A__B__AND_C__RABBI_EL from '@/components/xhtml/14_MEMO_THREE_A__B__AND_C__Rabbi_El'
 import XHTML15_CHAPTER_3__TOWARDS_THE_HEARTS_OF from '@/components/xhtml/15_CHAPTER_3__Towards_the_Hearts_of'
 import XHTML16_MEMO_FOUR__RABBAN_GAMLIEL_II_OF from '@/components/xhtml/16_MEMO_FOUR__Rabban_Gamliel_II_of'
 import XHTML17_CHAPTER_4__THE_GATE_OF_A_BROKEN from '@/components/xhtml/17_CHAPTER_4__The_Gate_of_a_Broken'
 import XHTML18_MEMO_FIVE__RABBI_AKIVA__SHIMON_B from '@/components/xhtml/18_MEMO_FIVE__Rabbi_Akiva__Shimon_b'
 import XHTML19_CHAPTER_5__REVELATION__RETRIBUTI from '@/components/xhtml/19_CHAPTER_5__Revelation__Retributi'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML20_ENDNOTES from '@/components/xhtml/20_Endnotes'
 import XHTML21_GLOSSARY from '@/components/xhtml/21_Glossary'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05_Contents",
 			"name" : "xhtml/05_Contents",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_A_Note_on_the_Title",
 			"name" : "xhtml/06_A_Note_on_the_Title",
 			"component" : XHTML06_A_NOTE_ON_THE_TITLE
 		},
 		{
 			"path" : "/xhtml/07_Acknowledgments",
 			"name" : "xhtml/07_Acknowledgments",
 			"component" : XHTML07_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/08_A_Novelist_Reads_the_Talmud__An",
 			"name" : "xhtml/08_A_Novelist_Reads_the_Talmud__An",
 			"component" : XHTML08_A_NOVELIST_READS_THE_TALMUD__AN
 		},
 		{
 			"path" : "/xhtml/09_Timeline_of_Relevant_Events__Acc",
 			"name" : "xhtml/09_Timeline_of_Relevant_Events__Acc",
 			"component" : XHTML09_TIMELINE_OF_RELEVANT_EVENTS__ACC
 		},
 		{
 			"path" : "/xhtml/10_MEMO_ONE__Rabbi_Yohanan_and_Rabb",
 			"name" : "xhtml/10_MEMO_ONE__Rabbi_Yohanan_and_Rabb",
 			"component" : XHTML10_MEMO_ONE__RABBI_YOHANAN_AND_RABB
 		},
 		{
 			"path" : "/xhtml/11_CHAPTER_1__Eros_and_Alchemy_in_t",
 			"name" : "xhtml/11_CHAPTER_1__Eros_and_Alchemy_in_t",
 			"component" : XHTML11_CHAPTER_1__EROS_AND_ALCHEMY_IN_T
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js